import { Stack, styled } from '@mui/material'

export const StyledMobileMenu = styled(Stack)(({ theme }) => ({
  position: 'relative',
  /*minHeight: '600px',*/
  backgroundColor: 'white',
  '&:first-of-type': {
    borderTop: '1px solid',
    borderColor: 'gray.light',
  },

  '.nav-link': {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(2, 4),
    borderBottom: '1px solid',
    borderColor: theme.palette.grey[300],
    color: theme.palette.primary.main,
    backgroundColor: 'white',
    textDecoration: 'none',
    cursor: 'pointer',
    fontWeight: 700,
    textDecoration: 'none',
    fontSize: '.875rem',
    '&.active': {
      
    },
	  '.MuiTypography-root.MuiTypography-nav, span': {
      fontSize: '.875rem',
    },
  },

  '.sub-nav': {
    width: '100%',
    position: 'relative',
    alignItems: 'center',
    '.sub-nav-link': {
      textDecoration: 'none',
      borderBottom: '1px solid',
      width: '100%',
      borderColor: theme.palette.grey[300],
      color: theme.palette.primary.main,
      padding: theme.spacing(1, 4, 1, 6),
      marginTop: 0,
      fontSize: '.875rem',
      
      '&:hover, &.active': {
        fontWeight: theme.typography.fontWeightBold,
  		  color: '#B85967',
		  textDecoration: 'underline',
      },
    },
  },
}))
